import { aggregatedClasses } from '@elliemae/ds-classnames';

var blockName = 'input-search';
var InputSearchWrapper = aggregatedClasses('div')(blockName);

export { InputSearchWrapper };
//# sourceMappingURL=blocks.js.map
